/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitButtonModule } from 'primeng/splitbutton';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { LmsLocoAssignmentComponent } from './data/lms-loco-assignment/lms-loco-assignment.component';
import { LmsLocoComponent } from './loco.component';
import { LmsLocoDataComponent } from './data/loco-data.component';
import { LmsLocoDataNotesComponent } from './data/lms-loco-data-notes/lms-loco-data-notes.component';
import { LmsLocoFeaturesComponent } from './data/lms-loco-features/lms-loco-features.component';
import { LmsLocoFuelComponent } from './data/lms-loco-fuel/lms-loco-fuel.component';
import { LmsLocoFuelSvgComponent } from './data/lms-loco-fuel-svg/lms-loco-fuel-svg.component';
import { LmsLocoHistoryComponent } from './history/loco-history.component';
import { LmsLocoInformationComponent } from './data/lms-loco-information/lms-loco-information.component';
import { LmsLocoInspectionComponent } from './data/lms-loco-inspection/lms-loco-inspection.component';
import { LmsLocoLastReportedComponent } from './data/lms-loco-last-reported/lms-loco-last-reported.component';
import { LmsLocoNotesComponent } from './notes/loco-notes.component';
import { LmsLocoProblemsComponent } from './data/lms-loco-problems/lms-loco-problems.component';
import { LmsLocoTopActionsComponent } from './data/lms-loco-top-actions/lms-loco-top-actions.component';
import { LmsLocoTripPlanComponent } from './data/lms-loco-trip-plan/lms-loco-trip-plan.component';
import { LmsLocoTripPlanListComponent } from './data/lms-loco-trip-plan-list/lms-loco-trip-plan-list.component';
import { LocoBlankString } from './pipes/loco-blank-string.pipe';
import { LocoDataResolver } from './shared/loco-data.resolver';
import { LocoDataService } from './services/loco-data.service';
import { LocoHistoryDetailsComponent } from './history/loco-history-details/loco-history-details.component';
import { LocoHistoryHeaderComponent } from './history/loco-history-header/loco-history-header.component';
import { LocoHistoryResolver } from './shared/loco-history.resolver';
import { LocoHistoryService } from './services/loco-history.service';
import { LocoNotesResolver } from './shared/loco-notes.resolver';
import { LocoProblemSortPipe } from './pipes/loco-problem-sort.pipe';
import { LocoRoutingModule } from './loco-routing.module';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

/*
 * @export
 * @class LocoModule
 */
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CoreModule,
        OverlayPanelModule,
        DropdownModule,
        AutoCompleteModule,
        InputMaskModule,
        DialogModule,
        SplitButtonModule,
        RadioButtonModule,
        CalendarModule,
        FormsModule,
        ReactiveFormsModule,
        LocoRoutingModule
    ],
    providers: [LocoDataService, LocoDataResolver, LocoNotesResolver, LocoHistoryResolver, LocoHistoryService],
    declarations: [LmsLocoComponent, LmsLocoComponent,
        LmsLocoFeaturesComponent,
        LmsLocoInspectionComponent,
        LmsLocoNotesComponent,
        LmsLocoProblemsComponent,
        LmsLocoTopActionsComponent,
        LmsLocoAssignmentComponent,
        LmsLocoLastReportedComponent,
        LmsLocoTripPlanComponent,
        LmsLocoFuelComponent,
        LmsLocoInformationComponent,
        LmsLocoTripPlanListComponent,
        LocoProblemSortPipe,
        LocoBlankString,
        LmsLocoFuelSvgComponent,
        LmsLocoHistoryComponent,
        LmsLocoDataComponent,
        LmsLocoDataNotesComponent,
        LocoHistoryDetailsComponent,
        LocoHistoryHeaderComponent,
    ],
    exports: [LmsLocoComponent, LocoBlankString]
})
export class LocoModule { }
